import React from 'react';
import { XMarkIcon, MagnifyingGlassIcon, CheckIcon } from '@heroicons/react/24/outline';

const MasterDataSelector = ({
  selectedMasterData,
  setSelectedMasterData,
  masterDataList,
  masterDataLoading,
  masterDataSearchTerm,
  setMasterDataSearchTerm,
  clientTypes,
  selectedClientType,
  setSelectedClientType,
  showMasterDataDropdown,
  setShowMasterDataDropdown,
  handleMasterDataSelect
}) => {
  const filteredMasterData = masterDataList.filter(item => {
    const matchesSearch = item.clientName?.toLowerCase().includes(masterDataSearchTerm.toLowerCase()) ||
                         item.clientAddress?.toLowerCase().includes(masterDataSearchTerm.toLowerCase()) ||
                         item.contactPersons?.some(contact => 
                           contact.name?.toLowerCase().includes(masterDataSearchTerm.toLowerCase()) ||
                           contact.email?.toLowerCase().includes(masterDataSearchTerm.toLowerCase())
                         );
    
    const matchesClientType = !selectedClientType || item.clientType === selectedClientType;
    
    return matchesSearch && matchesClientType;
  });

  return (
    <div className="bg-gray-50 p-6 rounded-lg">
      <h3 className="text-lg font-medium text-gray-900 mb-4">Select Client</h3>
      
      {selectedMasterData ? (
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <div className="flex items-center justify-between">
            <div>
              <h4 className="text-sm font-medium text-blue-900">Selected Client</h4>
              <p className="text-sm text-blue-700 mt-1">{selectedMasterData.clientName}</p>
              {selectedMasterData.clientAddress && (
                <p className="text-xs text-blue-600 mt-1">{selectedMasterData.clientAddress}</p>
              )}
            </div>
            <button
              type="button"
              onClick={() => setSelectedMasterData(null)}
              className="text-blue-500 hover:text-blue-700"
            >
              <XMarkIcon className="h-5 w-5" />
            </button>
          </div>
        </div>
      ) : (
        <div className="relative">
          <div className="flex space-x-3 mb-3">
            <div className="flex-1 relative master-data-dropdown">
              <MagnifyingGlassIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
              <input
                type="text"
                placeholder="Search by client name, address, or contact person..."
                value={masterDataSearchTerm}
                onChange={(e) => setMasterDataSearchTerm(e.target.value)}
                onFocus={() => setShowMasterDataDropdown(true)}
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <select
              value={selectedClientType}
              onChange={(e) => setSelectedClientType(e.target.value)}
              className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="">All Client Types</option>
              {Array.isArray(clientTypes) && clientTypes.map(type => (
                <option key={type._id} value={type._id}>
                  {type.name}
                </option>
              ))}
            </select>
          </div>

          {/* Master Data Dropdown */}
          {showMasterDataDropdown && (
            <div className="master-data-dropdown absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto">
              {masterDataLoading ? (
                <div className="flex justify-center items-center py-4">
                  <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
                </div>
              ) : filteredMasterData.length === 0 ? (
                <div className="p-4 text-center text-gray-500">
                  No clients found
                </div>
              ) : (
                <div className="py-1">
                  {filteredMasterData.map((item) => (
                    <button
                      key={item._id}
                      type="button"
                      onClick={() => handleMasterDataSelect(item)}
                      className="w-full text-left px-4 py-2 hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                    >
                      <div className="flex items-center justify-between">
                        <div>
                          <div className="font-medium text-gray-900">{item.clientName}</div>
                          {item.clientAddress && (
                            <div className="text-sm text-gray-600">{item.clientAddress}</div>
                          )}
                        </div>
                        <CheckIcon className="h-5 w-5 text-blue-600" />
                      </div>
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MasterDataSelector; 